/** The media box of a one-column tray card: a fixed height, the full row wide. */
export const TRAY_SINGLE_COLUMN_BOX_CLASS = 'h-[var(--panel-single-grid-height)]'

/** The media box of a two-column tray card, as an aspect ratio (Backgrounds' squarish default). */
export const TRAY_TWO_COLUMN_BOX_CLASS = 'aspect-[120/97.5]'

/**
 * Size classes for a tray thumbnail's media box, so every tray that lays out cards the Backgrounds
 * way shares one definition. A tray whose items have a different shape passes its own
 * `twoColumnBoxClass` (Templates' 3:2 spread previews) and keeps the single-column height.
 */
export function trayThumbnailBoxClassName(
  columns: 1 | 2,
  twoColumnBoxClass: string = TRAY_TWO_COLUMN_BOX_CLASS
): string {
  return columns === 1 ? TRAY_SINGLE_COLUMN_BOX_CLASS : twoColumnBoxClass
}
